import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Dashboard from "./Components/Dashboard";
import Cart from "./Components/Cart";
import Payment from "./Components/Payment";
import TopNav from "./Components/TopNav";
import LoginPopup from "./Components/LoginPopup";
import HeritageSeedsPage from "./Components/HeritageSeedsPage";
import Equipment from "./Components/Equipment";
import Nutri from "./Components/nutri";
import Protection from "./Components/Protection";
import Soils from "./Components/Soils";
import Gardening from "./Components/Gardening";
import Knowledge from "./Components/knowledge";
import ProductDetails from "./Components/ProductDetails";
import TrackMyOrder from "./Components/TrackMyOrder";

const App = () => {
  const [cartItems, setCartItems] = useState([]);
  const [likedItems, setLikedItems] = useState([]);
  const [user, setUser] = useState(null);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [pendingCartItem, setPendingCartItem] = useState(null);
  const [pendingLikeItem, setPendingLikeItem] = useState(null);

  useEffect(() => {
      if (user) {
        setIsLoginOpen(false);
      }
      if (user && pendingCartItem) {
        addToCart(pendingCartItem);  // Retry adding item
        setPendingCartItem(null);    // Clear it
    }
    if (user && pendingLikeItem) {
      addToCart(pendingLikeItem);  // Retry adding item
      setPendingLikeItem(null);    // Clear it
  }
    }, [user]);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
    const userId = user ? user.userId : null; // Safely extract userId
    const fetchCartItems = async () => {
      if (!user) return;
      try {
        const response = await fetch(`https://backend-matihaat.onrender.com/cart/${user.userId}`);
        const data = await response.json();
        setCartItems(data || []);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };
    
    const fetchLikedItems = async () => {
      if (!user) return;
      try {
        const response = await fetch(`https://backend-matihaat.onrender.com/liked/${user.userId}`);
        const data = await response.json();
      } catch (error) {
        console.error("Error fetching liked items:", error);
      }
    };  
    
    if (userId) {
      fetchCartItems();
      // fetchLikedItems();
    }
  }, []);

  
  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
    const savedLikes = JSON.parse(localStorage.getItem("likedItems")) || [];
    setCartItems(savedCart);
    setLikedItems(savedLikes);
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
      fetchUserCart(JSON.parse(savedUser).userId);
      fetchUserLikes(JSON.parse(savedUser).userId);
    }
  }, []);

  const fetchUserCart = async (userId) => {
    try {
      const response = await fetch(`https://backend-matihaat.onrender.com/cart/${userId}`);
      const data = await response.json();
      setCartItems(data);
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };

  const fetchUserLikes = async (userId) => {
    try {
      const response = await fetch(`https://backend-matihaat.onrender.com/liked/${userId}`);
      const data = await response.json();
      setLikedItems(data);
    } catch (error) {
      console.error("Error fetching liked items:", error);
    }
  };

  const addToCart = async (item) => {
    if (!user) {
        alert("Please log in to add items to the cart.");
        setIsLoginOpen(true);
        setPendingCartItem(item);
        return;
    }

    try {
        const response = await fetch("https://backend-matihaat.onrender.com/cart/add", {
            method: "POST",
            headers: { "Content-Type": "application/json" }, // Ensure correct Content-Type
            body: JSON.stringify({
                userId: user.userId,  // Pass userId
                item: item // Send full item object
            }),
        });

        const data = await response.json();
        if (data.success) {
            console.log(data.cart);
            setCartItems(data.cart); // Update state with full item details
        } else {
            console.error("❌ Backend Error:", data.message);
        }
    } catch (error) {
        console.error("Error adding to cart:", error);
    }
};


  const likeItem = async (item) => {
    if (!user) {
      alert("Please log in to add items to the cart.");
      setIsLoginOpen(true);
      setPendingLikeItem(item);
      return;
  }

  try {
      const response = await fetch("https://backend-matihaat.onrender.com/liked/add", {
          method: "POST",
          headers: { "Content-Type": "application/json" }, // Ensure correct Content-Type
          body: JSON.stringify({
              userId: user.userId,  // Pass userId
              item: item  // Send full item object
          }),
      });

      const data = await response.json();
  } catch (error) {
      console.error("Error adding to cart:", error);
  }
  };
  
  const handleCartClick = async (product) => {
    await addToCart(product);
  };

  const removeFromLiked = async (item) => {
    if (!user) return;
  
    try {
      const response = await fetch("https://backend-matihaat.onrender.com/liked/remove", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.userId,
          itemId: item.id,
        }),
      });
  
      const data = await response.json();
      if (data.success) {
        setLikedItems((prevItems) =>
          prevItems.filter((likedItem) => likedItem.itemId !== item.id)
        );
      }
    } catch (error) {
      console.error("Error removing liked item:", error);
    }
  };

 const handleLikeClick = async (product) => {
    await likeItem(product);
    setLikedItems((prevItems) => [...prevItems, product]);
  };
  

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <> 
                <Header
                  cartItems={cartItems}
                  likedItems={likedItems}
                  addToCart={addToCart}
                  removeFromLiked={removeFromLiked}
                  onLoginClick={() => setIsLoginOpen(true)}
                  user={user}
                  setUser={setUser}
                  setCartItems={setCartItems} 
                  setLikedItems={setLikedItems}
                />
                <Dashboard
                  handleCartClick={handleCartClick}
                  handleLikeClick={handleLikeClick}
                  user={user}
                />
              </>
            }
          />
          <Route
            path="/cart"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                <Cart cartItems={cartItems} />
              </>
            }
          />
           <Route
            path="/Equipment"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <Equipment handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
          <Route
            path="/Knowledge"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <Knowledge handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
          <Route
            path="/Soils"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <Soils handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
          <Route
            path="/gardening"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <Gardening handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
           <Route
            path="/protection"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <Protection handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
          <Route
            path="/nutrition"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <Nutri handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
          <Route
            path="/heritage-seeds"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <HeritageSeedsPage handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
          <Route
            path="/payment"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <Payment/>
              </>
            }
          />
          <Route
            path="/track-order"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <TrackMyOrder/>
              </>
            }
          />
          <Route
            path="/product/:productName"
            element={
              <>
                <TopNav
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}
                />
                 <ProductDetails handleCartClick={handleCartClick} handleLikeClick={handleLikeClick}  
                 cartItems={cartItems}
                 likedItems={likedItems}
                 addToCart={addToCart}
                 removeFromLiked={removeFromLiked}
                 onLoginClick={() => setIsLoginOpen(true)}
                 user={user}
                 setUser={setUser}
                 setCartItems={setCartItems} 
                 setLikedItems={setLikedItems}/>
              </>
            }
          />
        </Routes>
      </div>

      {/* Login Popup */}
      <LoginPopup   setUser={setUser} isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} onLogin={setUser}/>
    </BrowserRouter>
  );
};

export default App;
